<template>
  <div>
    <label :for="handle">{{ label }}</label>
    <div class="input-group">
      <input type="text"
             class="form-control input-sm frontendDatepicker"
             :class="inputClass"
             autocomplete="off"
             :placeholder="placeholder"
             v-model="setValue"
             :id="handle + '-' + _uid"
             :name="handle"/>
      <div class="input-group-addon input-sm">
        <i class="icon icon-calendar"></i>
      </div>
    </div>
  </div>
</template>
<style></style>
<script>
export default {
  name: "filter-criteria-date",
  props: {
    label: String,
    handle: String,
    placeholder: String,
    inputClass: String,
    value: [ String, Boolean ]
  },
  computed: {
    el: function() {
      return '#' + this.handle + '-' + this._uid + '.frontendDatepicker';
    }
  },
  data: function () {
    return {
      setValue: this.value,
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      this.setValue = newVal;
    },
  },
  methods: {
    emitToParent () {
      this.$emit('input', this.setValue);
    }
  },
  mounted() {
    // Init the DatePicker
    var self = this;
    var dp = $(this.el).datepickerBootstrap({
      container: '.ccm-page header',
      format: "dd.mm.yyyy",
      todayBtn: "linked",
      language: "de",
      daysOfWeekHighlighted: "0,6",
      autoclose: true,
      calendarWeeks: true,
      placeholder: this.placeholder,
      todayHighlight: true,
      zIndexOffset: 1001
    }).on('change', function(e){
      self.setValue = $(self.el).val();
      self.emitToParent();
    });
    $(this.el).next().click(function(e){
      dp.datepickerBootstrap('show');
    });
  },
  destroyed: function() {
    $(this.el).datepickerBootstrap("destroy");
  }
}
</script>
